var $ = require("jquery");

export const showLoading = (msg: string) => {
    $('#loading-message').html(msg);
    $('#page-spinner').removeClass("loading-hide");
}

export const hideLoading = () => {
    $('#page-spinner').addClass("loading-hide");
}